import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  onModalAction(event: any) {
    this.dispatch("onModalAction", { detail: event.params });
    this.closeModal();
  }

  closeModal() {
    this.element.remove();
  }

  submitForm(action) {
    action.preventDefault();
    action.target.closest("form").submit();
    this.closeModal();
  }
}
